/*
 * -----------------------------------------------------------------------------
 * -----------------------------------------------------------------------------
 * ADDITIONS
 * -----------------------------------------------------------------------------
 * SR UPDATE 1 - DISABLE SEARCH
 * SR UPDATE 2 - FIRE CHOSEN:UPDATED EVENT WHEN ELEMENT HTML CHANGES
 * SR UPDATE 3 - ENSURE MODEL IS DEFINED (INCLUDING NULL)
 * -----------------------------------------------------------------------------
 * -----------------------------------------------------------------------------
 * Use this directive to convert drop downs into chosen drop downs.
 * http://harvesthq.github.io/chosen/
 * http://adityasharat.github.io/angular-chosen/
 */
(function (angular) {
	var AngularChosen = angular.module('angular.chosen', []);

	AngularChosen.directive('chosen', ['$timeout', function ($timeout) {
			var EVENTS, scope, linker, watchCollection;

			/*
			 * List of events and the alias used for binding with angularJS
			 */
			EVENTS = [{
					onChange: 'change'
				}, {
					onReady: 'chosen:ready'
				}, {
					onMaxSelected: 'chosen:maxselected'
				}, {
					onShowDropdown: 'chosen:showing_dropdown'
				}, {
					onHideDropdown: 'chosen:hiding_dropdown'
				}, {
					onNoResult: 'chosen:no_results'
				}];

			/*
			 * Items to be added in the scope of the directive
			 */
			scope = {
				userOptions: '=',
				options: '=', // the options array
				ngModel: '=', // the model to bind to,,
				ngDisabled: '='
			};

			/*
			 * initialize the list of items
			 * to watch to trigger the chosen:updated event
			 */
			watchCollection = [];
			Object.keys(scope).forEach(function (scopeName) {
				watchCollection.push(scopeName);
			});

			/*
			 * Add the list of event handler of the chosen
			 * in the scope.
			 */
			EVENTS.forEach(function (event) {
				var eventNameAlias = Object.keys(event)[0];
				scope[eventNameAlias] = '=';
			});

			/* Linker for the directive */
			linker = function ($scope, iElm, iAttr) {
				
				var defaultOptions = {
					width: '100%',
					disable_search_threshold: 20,
					search_contains: true,
					placeholder_text_multiple: 'Please select'
				};
				var userOptions = $scope.userOptions || {};
				var mergedOptions = angular.extend(defaultOptions, userOptions);

				iElm.chosen(mergedOptions);

				iElm.on('change', function () {
					iElm.trigger('chosen:updated');
					// Trigger validation
					if (typeof iElm.valid == 'function') {
						iElm.valid();
					}
				});

				/*
				 * SR UPDATE 3
				 */
				$scope.$watch('ngModel', function (newValue, oldValue) {
					if (angular.isUndefined(newValue)) {
						$scope.ngModel = null;
					}
				});

				$scope.$watchGroup(watchCollection, function () {
					$timeout(function () {
						iElm.trigger('chosen:updated');
					}, 0);
				});

				/*
				 * SR UPDATE 2
				 */
				$scope.$watch(
					function () {
						return iElm.html();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							iElm.trigger('chosen:updated');
						}
					}
				);

				// assign event handlers
				EVENTS.forEach(function (event) {
					var eventNameAlias = Object.keys(event)[0];

					if (typeof $scope[eventNameAlias] === 'function') { // check if the handler is a function
						iElm.on(event[eventNameAlias], function (event) {
							$scope.$apply(function () {
								$scope[eventNameAlias](event);
							});
						}); // listen to the event triggered by chosen
					}
				});
			};

			postLinker = function ($scope, iElm, iAttr) {
				$timeout(function () {
					iElm.trigger('chosen:updated');
				}, 0);
			}

			// return the directive
			return {
				name: 'chosen',
				scope: scope,
				restrict: 'A',
				link: {
					pre: linker,
					post: postLinker
				}
			};
		}]);
}(angular));